import Vue from 'vue'
import Supplier from "Models/Supplier"
import Employee from "Models/Employee"
import Role from "Models/Role"
import Permission from "Models/Permission"
import Customer from "Models/Customer"
import County from "Models/StaticData/County"
import Workstation from "Models/Workstation"
import Invoice from "Models/Invoice"
import Equipment from "Models/Equipment"
import Transport from "Models/Transport"
import ConstructionEstimate from "Models/ConstructionEstimate"
import ConstructionEstimateProduct from "Models/ConstructionEstimateProduct"
import Offer from "Models/Offer"
import OfferProduct from "Models/OfferProduct"
import Product from "Models/Product"
import Comment from "Models/Comment"
import EquipmentWorksheet from "Models/EquipmentWorksheet"
import CustomerNotification from "Models/CustomerNotification"
import CustomerFeedback from "Models/CustomerFeedback"
import Presence from "Models/Presence"
import Holiday from "Models/Holiday"
import InternalAquisition from "Models/InternalAquisition"

import Expense from "Models/Expense"
import ExpenseItem from "Models/ExpenseItem"

class Api {
    constructor()
    {
        this.$http = window.axios
        Vue.prototype.$db = this

        this.County = County

        this.Supplier = Supplier
        this.Employee = Employee
        this.Role = Role
        this.Permission = Permission
        this.Workstation = Workstation
        this.Invoice = Invoice
        this.Transport = Transport
        this.Offer = Offer
        this.OfferProduct = OfferProduct
        this.Product = Product
        this.Comment = Comment
        this.EquipmentWorksheet = EquipmentWorksheet

        this.ConstructionEstimate = ConstructionEstimate
        this.ConstructionEstimateProduct = ConstructionEstimateProduct

        this.Customer = Customer
        this.Equipment = Equipment
        this.CustomerNotification = CustomerNotification
        this.CustomerFeedback = CustomerFeedback

        this.Presence = Presence
        this.Holiday = Holiday

        this.InternalAquisition = InternalAquisition

        this.Expense = Expense
        this.ExpenseItem = ExpenseItem
    }
}

export default new Api()
